import { SVGProps, Ref, forwardRef } from 'react';

export const ItAccreditationFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1m3.4 16.5v-5.7H17V10h-1.6V7h-1.8v3H12v1.8h1.6v5.7zm-5-7.5H7v1.8h1.6v5.7h1.8zm-.9-1.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
                fill="currentColor"
            />
        </svg>
    )
);
ItAccreditationFilledSize24Glyph.displayName = 'ItAccreditationFilledSize24Glyph';
